import { Component } from '@angular/core';

@Component({
  selector: 'app-ie-not-supported',
  templateUrl: './ie-not-supported.component.html',
  styleUrls: ['./ie-not-supported.component.scss'],
})
export class IENotSupportedComponent {}
